import request from '@/utils/request'

export function getLearningAnalyticsReportData(params) {
  return request({
    url: '/learning-analytics/report-data',
    method: 'get',
    params
  })
}

export function exportLearningAnalyticsPdf(params) {
  return request({
    url: '/learning-analytics/export-pdf',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
